import axios from "axios";

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (axios.isCancel(error)) {
      return;
    }
    if (error.config.url.includes("gtin/Consultar")) {
      return Promise.reject(error);
    }
    if (
      window.location.pathname != "/erro/401" &&
      window.location.pathname != "/erro/404" &&
      window.location.pathname.indexOf("/validar") === -1 &&
      !error.config.url.includes("Login/ValidarToken")
    ) {
      switch (parseInt(error.response.status)) {
        case 401:
          localStorage.removeItem("token");
          localStorage.removeItem("nome_usuario");
          localStorage.removeItem("primeiro_login");
          localStorage.removeItem("usuario_pro");
          window.location = "/erro/401";
          break;
        case 404:
          window.location = "/erro/404";
          break;
        case 500:
          return Promise.reject({
            status: 500,
            data: [],
            dados: [],
            error: true,
            response: {
              status: false,
              data: [],
              dados: []
            }
          });
          break;
        default:
          return Promise.reject(error);
      }
    }
  }
);

let sources = {};
export default class Api {
  constructor(production = false) {
    this.production = production;
  }
  post(url, dados, prod = false, id = null) {
    if (id) {
      sources[id] = new axios.CancelToken.source();
    }
    // console.log(sources);
    try {
      if (dados && dados.regra && typeof dados.regra == "string" && dados.regra != "") {
        dados.regra = Number.parseInt(dados.regra);
      }
    } catch (e) {
      console.error(e);
    }
    let token = this.getToken();
    let vueAppRootApi = "";
    return axios
      .post(
        (prod ? "https://rte-api.econeteditora.com.br/" : this.getConexao()) + url,
        {
          ...dados
        },
        {
          headers: {
            Authorization: "Bearer " + token
          },
          cancelToken: sources[id] ? sources[id].token : null
        }
      )
      .then(response => {
        return response.data;
      });
  }
  cancel(id) {
    if (sources[id]) {
      sources[id].cancel("requisição cancelada");
    }
    sources[id] = new axios.CancelToken.source();
  }
  downloadFile(url, dados) {
    let token = this.getToken();
    return new Promise((resolve, reject) => {
      return axios
        .post(
          this.getConexao() + url,
          {
            ...dados
          },
          {
            responseType: "blob",
            headers: {
              Authorization: "Bearer " + token
            }
          }
        )
        .then(response => {
          // console.log(new Blob(response.data));
          resolve(response.data);
        })
        .catch(error => {
          console.log(error);
          reject(error.response);
        });
    });
  }

  get(url) {
    let token = this.getToken();
    const baseUrl = this.production ? "https://rte-api.econeteditora.com.br/" : this.getConexao();
    return axios
      .get(baseUrl + url, {
        headers: {
          Authorization: "Bearer " + token
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error.response;
      });
  }

  delete(url) {
    let token = this.getToken();
    return axios
      .delete(this.getConexao() + url, {
        headers: {
          Authorization: "Bearer " + token
        }
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  }

  file(url, dados) {
    let token = this.getToken();
    return axios
      .post(this.getConexao() + url, dados, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token
        }
      })
      .then(response => {
        return response.data;
      });
  }

  impressao(url, dados) {
    let token = this.getToken();
    //Chupa blob
    return axios({
      url: this.getConexao() + url,
      method: "POST",
      data: dados,
      headers: {
        Accept: "application/pdf",
        Authorization: "Bearer " + token
      },
      responseType: "blob"
    }).then(response => {
      return response;
    });
  }
  redirectError(statusCode) {
    // localStorage.removeItem('token');
    // localStorage.removeItem('nome_usuario');
    // localStorage.removeItem('primeiro_login');
    // localStorage.removeItem('usuario_pro');
    switch (parseInt(statusCode)) {
      case 401:
        // window.location = '/erro/401';
        break;
      case 404:
      default:
        // window.location = '/erro/404';
        break;
    }
  }

  getToken() {
    if (localStorage.getItem("token_simulacao")) {
      return localStorage.getItem("token_simulacao");
    } else if (localStorage.getItem("token")) {
      return localStorage.getItem("token");
    } else {
      return false;
    }
  }

  getConexao() {
    let url = window.location.href.toString();

    if (url.indexOf("http://localhost") > -1) {
      return process.env.VUE_APP_ROOT_API_LOCAL;
    }

    if (url.indexOf("rte-dev.econeteditora.com.br") > -1) {
      return process.env.VUE_APP_ROOT_API_DEV;
    }

    if (url.indexOf("rte-homol.econeteditora.com.br") > -1) {
      return process.env.VUE_APP_ROOT_API_HOMOL;
    }

    if (url.indexOf("rte.econeteditora.com.br") > -1) {
      return process.env.VUE_APP_ROOT_API_PROD;
    }

    return process.env.VUE_APP_ROOT_API_DEV;
  }
}
